export default __webpack_public_path__ + "static/media/cairns-loading.e9178664.gif";